<div class="tp-card">
  <div class="tp-toolbar">
    <div class="tp-search">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="20" y1="20" x2="16.65" y2="16.65"></line></svg>
      <input type="text" [value]="searchQuery" (input)="filterTable($event)" placeholder="Rechercher ..." />
    </div>
  </div>

  <div class="tp-table-wrap">
    <table class="tp-table">
      <thead>
        <tr>
          <th>{{ idTitle }}</th>
          <th *ngIf="isTransfer">Bénéficiaire</th>
          <th>Date</th>
          <th class="col-center">Montant</th>
          <th>Statut</th>
          <th *ngIf="showInvoice" class="col-center">Facture</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of pagedData; trackBy: trackById">
          <td>{{ row.id }}</td>
          <td *ngIf="isTransfer">{{ row.to || '—' }}</td>
          <td class="tp-muted">{{ formatDate(row.date) }}</td>
          <td class="col-center tp-amount">{{ formatNumber(row.amount) }}</td>
          <td>
            <span class="tp-badge tp-badge--{{ statusKind(row.status) }}">
              <svg *ngIf="statusKind(row.status) === 'success'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <svg *ngIf="statusKind(row.status) === 'danger'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              <svg *ngIf="statusKind(row.status) === 'pending'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15 14"></polyline></svg>
              {{ statusLabel(row.status) }}
            </span>
          </td>
          <td *ngIf="showInvoice" class="col-center">
            <button type="button" class="invoice-btn" [disabled]="!canDownload(row)"
              [title]="canDownload(row) ? 'Télécharger la facture' : 'Facture disponible une fois la commande confirmée'"
              (click)="onDownload(row)">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path></svg>
            </button>
          </td>
        </tr>
        <tr *ngIf="!filteredData.length">
          <td colspan="5" class="tp-empty">{{ emptyText }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="tp-footer" *ngIf="totalPages > 1">
    <span>Affichage {{ rangeStart }} à {{ rangeEnd }} sur {{ filteredData.length }} entrées</span>
    <div class="tp-pager">
      <button type="button" class="tp-page-btn" [disabled]="page === 1" (click)="goTo(page - 1)">← Précédent</button>
      <button type="button" *ngFor="let p of pages" class="tp-page-btn" [class.is-current]="p === page" (click)="goTo(p)">{{ p }}</button>
      <button type="button" class="tp-page-btn" [disabled]="page === totalPages" (click)="goTo(page + 1)">Suivant →</button>
    </div>
  </div>
</div>